export default "/images/42c58a2200f95bd3881908601adeefc3.jpg";